export function gallery(state) {
    return state.gallery
}

export function getIrSaving(state) {
    return state.irSaving
}

export function getWidgetStructure(state) {
    return state.widgetStructure
}

export function getIrSavingData(state) {
    return state.irSavingData
}

